import { Control, Controller } from "react-hook-form";
import { ClipboardList } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { CustomPolicyFormData } from "./custom-policy.form";
import { CustomPolicySectionCard } from "./customPolicySectionCard";
import { useTranslation } from "react-i18next";

type Props = {
  control: Control<CustomPolicyFormData>;
};

export const CustomPolicyProcedureSection = ({ control }: Props) => {
  const { t } = useTranslation("boCustoms");
  return (
    <CustomPolicySectionCard icon={ClipboardList} title={t("policyProcedure.title")}>
      <Controller
        control={control}
        name="procedure"
        render={({ field }) => (
          <Textarea
            value={field.value ?? ""}
            onChange={(e) => field.onChange(e.target.value || null)}
            placeholder={t("policyProcedure.placeholder")}
            className="min-h-[200px]"
          />
        )}
      />
    </CustomPolicySectionCard>
  );
};
